import { render, staticRenderFns } from "./OverduePayments.vue?vue&type=template&id=29673c03&"
import script from "./OverduePayments.vue?vue&type=script&lang=js&"
export * from "./OverduePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports